// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_1SPkX","locked":"index_locked_O9Q0n"};